import React from 'react';
import {RoutePermittedRole} from '../../shared/constants/AppConst';

// Lazy load the UsersPage component
const UsersPage = React.lazy(() => import('./UsersPage'));

// Export the route configuration
export const usersConfig = [
  {
    permittedRole: RoutePermittedRole.admin,
    path: '/users',
    element: <UsersPage />,
  },
];

// Also export the component as default for direct imports
export {default} from './UsersPage';
